import Check from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@src/common/components/button/Button';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { useTranslation } from 'react-i18next';

interface Props {
  onContinue: () => void;
  onClose: () => void;
  disabled: boolean;
}
export const DuplicateOrderFooter = ({
  onContinue,
  onClose,
  disabled,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Stack
      zIndex={10}
      position="sticky"
      bottom="0"
      style={{ backgroundColor: theme.palette.surface.surface }}
      paddingBottom={theme.spacing['6']}
      marginX="40px"
    >
      <Divider style={{ marginBottom: theme.spacing['6'] }} />
      <Stack direction="row" justifyContent="space-between">
        <Button
          type="button"
          onClick={onClose}
          variant="text"
          startIcon={<CloseIcon />}
        >
          {t('close')}
        </Button>
        <Stack direction="row" gap={theme.spacing['2']}>
          <Button
            type="submit"
            disabled={disabled}
            onClick={onContinue}
            startIcon={<Check />}
            variant="contained"
          >
            {t('continue')}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
